import { IPartner } from './Partner';
import { IPet } from './Pet';
import { Symptoms } from './Treatment';
import { ITutor } from './Tutor';
import { IPaginatedResult } from './Util';
import { IVet } from './Vet';

export interface IAdminReport {
  _id: string;
  pet?: IPet | any;
  vet?: IVet | any;
  tutor?: ITutor | any;
  createdAt: string;
  updatedAt: string;
  callUrl: string;
  baseUrl: string;
  annotations: string;
  symptoms: Symptoms[];
  isFinished: Boolean;
  finishedAt: Date;
  finishedQueueAt: Date;
  startedQueueAt: Date;
  evaluation: any;
  treatmentHappened: Boolean;
  generalClassification: string;
}

export const AdminReportDefaultValues: IAdminReport = {
  pet: '',
  _id: '',
  vet: '',
  tutor: '',
  createdAt: '',
  updatedAt: '',
  callUrl: '',
  baseUrl: '',
  annotations: '',
  symptoms: [{name: '', _id: '', classification: 'URGENCY' , number: 1}],
  isFinished: false,
  finishedAt: new Date(),
  startedQueueAt: new Date(),
  finishedQueueAt: new Date(),
  treatmentHappened: false,
  evaluation: {},
  generalClassification: '',
};

export type IAdminReportResult = IPaginatedResult<IAdminReport>;

export type IAdminReportPartnersResult = IPaginatedResult<IPartner>;
